import DeleteIcon from '../../../assets/svg/delete-black.svg?react';
import DownloadIcon from '../../../assets/svg/download-black.svg?react';
import styles from './FJMobileSelectAll.module.less';
import classNames from 'classnames';
import FJLocalStore from '../../../store/FJLocalStore';
import PropTypes from 'prop-types';
import FJCheckBox from '../../../common/components/FJCheckBox/FJCheckBox';
import FJHoverBoardGradation from '../../../common/components/FJHoverBoard/FJHoverBoardGradation';

const FJMobileSelectAll = props => {
    const { list, selectList, multiDownload, multiDelete, setSelectList, batchDownloadLoading, isMobileMultiSelect } =
        props;
    const isShow = isMobileMultiSelect;
    const selectNumber = selectList.length;
    const _multiDelete = () => {
        if (!selectList?.length) return;
        multiDelete(selectList);
    };
    const clearSelected = () => {
        setSelectList([]);
    };
    const isSelectedAll = selectList?.length >= list?.length;
    const _selectAll = () => {
        if (isSelectedAll) {
            clearSelected();
        } else {
            setSelectList(list.map(i => i?.id));
        }
    };
    const _onBatchDownload = () => {
        if (batchDownloadLoading) {
            return;
        }
        multiDownload && multiDownload(selectList, 'multiple choose');
    };
    const hasSelect = selectList?.length > 0;
    return (
        <div className={classNames(styles.select_all_box, isShow ? styles.show : styles.hide)}>
            <FJCheckBox
                dataChange={_selectAll}
                selected={isSelectedAll}
                value={FJLocalStore._('select-all')}
                type='circle'
                textClassName={styles.select_all_text}
            />
            <div className={styles.middle}>
                {selectNumber +
                    ' ' +
                    (selectNumber > 1 ? FJLocalStore._('files-selected') : FJLocalStore._('file-selected'))}
            </div>
            <div className={styles.right}>
                <div className={classNames(styles.icon_box, { [styles.disabled]: !hasSelect })} onClick={_multiDelete}>
                    <DeleteIcon />
                </div>
                <FJHoverBoardGradation
                    active={true}
                    contentClassName={styles.download}
                    onClick={_onBatchDownload}
                    borderRadius={20}
                    className={classNames(styles.download_box, { [styles.disabled]: !hasSelect })}
                >
                    <DownloadIcon className={styles.download_icon} />
                </FJHoverBoardGradation>
            </div>
        </div>
    );
};
FJMobileSelectAll.propTypes = {
    list: PropTypes.array,
    selectList: PropTypes.array,
    multiDownload: PropTypes.func,
    multiDelete: PropTypes.func,
    setSelectList: PropTypes.func,
    batchDownloadLoading: PropTypes.bool,
    hideDownload: PropTypes.bool,
    isMobileMultiSelect: PropTypes.bool,
};
export default FJMobileSelectAll;
